var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-list-item-avatar',{attrs:{"color":"primary","size":"28"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.nameFirstChar))])]),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.profile))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }